<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>账号信息</p>
        </div>
        <div class="organiza-cont">
          <div class="detail">
            <p class="detail-title">账号信息</p>
            <div class="info">
              <div class="info-item" v-if="reviseType">
                <p class="info-title">用户名：</p>
                <input type="text" v-model="userName" :placeholder="userData.name">
                <button class="btn btn-sub" @click="reviseSub">确认</button>
                <button class="btn btn-close" @click="reviseType=false;">取消</button>
              </div>
              <div class="info-item" v-else>
                <p class="info-title">用户名：</p>
                <p>{{userData.name}}</p>
                <button class="btn btn-revise" @click="reviseType=true;">修改</button>
              </div>
              <div class="info-item">
                <p class="info-title">手机号：</p>
                <p>{{userData.mobile}}</p>
              </div>
            </div>
          </div>

          <div class="detail">
            <p class="detail-title">修改密码</p>
            <div class="info">
              <div class="info-item">
                <p class="info-title">当前密码:</p>
                <input type="text" v-model="passObj.old_password">
              </div>
              <div class="info-item">
                <p class="info-title">新密码:</p>
                <input type="text" v-model="passObj.password">
              </div>
              <div class="info-item">
                <p class="info-title">确认密码:</p>
                <input type="text" v-model="Nowpassword">
              </div>
            </div>
            <div class="btnBox">
              <button class="btn btn-sub" @click="passSub">确认修改</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getUserDetail,updateUserName,accountUpdatePassword } from "@/assets/js/api";
export default {
  name: "topic-config",
  data() {
    return {
      navId:'5',
      childrenID:'5-3',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'角色名称'},
        {id:3,title:'权限'},
        {id:4,title:'操作'},
      ],
      dataList:[],
      currentPage1: 2,
      authorityType:false,
      addType:false,
      token:"",
      userData:'',
      reviseType:false,
      userName:'',
      passObj:{
        old_password:'',
        password:'',
      },
      Nowpassword:'',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token =this.$refs.navBox.userData.token;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    getList(){
      var that = this;
      getUserDetail(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.userData = data.data;
        } else { 
          taht.$message(data.meg);
        }
      })
    },

    reviseSub(){
      var that = this;
      updateUserName({name:this.userName},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！');
          that.getList();
          that.reviseType = false;
          that.$refs.myHeader.getUser();
        } else { 
          taht.$message(data.meg);
        }
      })
    },

    passSub(){
      var that = this;
      if(this.passObj.old_password == ''){
        that.$message('请输入原始密码！');
        return false;
      };
      if(this.passObj.password == ''){
        that.$message('请输入新密码！');
        return false;
      };
      if(this.Nowpassword == ''){
        that.$message('请确认新密码！');
        return false;
      };
      if(this.Nowpassword != this.passObj.password){
        that.$message('新密码与确认密码不一致！');
        return false;
      };
      accountUpdatePassword(this.passObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！请重新登录');
          that.passObj={
            old_password:'',
            password:'',
          };
          that.Nowpassword='';
          that.$refs.myHeader.LogOut();
        } else { 
          that.$message(data.msg);
        }
      })
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 25%;
}

.organiza-txt{
  height: calc(100% - 120px);
}

.organiza-cont .detail-title{
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #3D3D3D;
}

.organiza-cont .info-item {
  margin-bottom: 30px;
}

.organiza-cont .info-item p{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
}

.organiza-cont .info-item p.info-title{
  width: 100px;
}

.organiza-cont .info-item input{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  width: 300px;
  line-height: 36px;
  height: 36px;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 5px 10px;
}

.organiza-cont .info-item button{
  color: #457AFF;
  font-size: 20px;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
  margin-left: 18px;
}

.detail .btnBox .btn-sub{
  background-color: #457AFF;
  padding: 10px 30px;
  font-size: 15px;
  color: #fff;
  border-radius: 20px;
}

</style>



// WEBPACK FOOTER //
// src/admin/account.vue